import React, { useState } from "react";
import ColumnHeader from "./ColumnHeader";
import { getHeaderTooltip } from "./tooltips";
import {
  UncontrolledButtonDropdown,
  DropdownMenu,
  Nav,
  NavLink,
  DropdownToggle,
} from "reactstrap";

export default function FvFbHeader({
  value,
  setValue,
  name,
  options = [],
  isHidden,
  isLock,
  direction = "down",
}) {
  const [isOpen, setIsOpen] = useState(false);

  const normalizedName = name ? name.toString().trim().replace(/\s+/g, "").toUpperCase() : "";
  const handleClick = (newValue) => {
    setIsOpen(false);
    setValue(newValue);
  };

  const handleOpen = () => {
    if (isHidden) return;
    setIsOpen((prev) => !prev);
  };

  return (
    <div className="dropdown-wrapper" style={{ position: "relative" }}>
      <UncontrolledButtonDropdown isOpen={isOpen} direction={direction}>
        <DropdownToggle tag="div" color="link" className="p-0">
          <ColumnHeader
            name={name}
            value={value}
            isLock={isLock}
            onClick={handleOpen}
          />
        </DropdownToggle>

        <DropdownMenu
          className={`rm-pointers dropdown-menu-lg menu-dropdown planscreen__dropdown--fvfb ${
            isOpen ? "planscreen__dropdown--open" : "planscreen__dropdown"
          }`}
          container="body"
          strategy="fixed"
          popperConfig={{
            strategy: "fixed",
            modifiers: [
              { name: "preventOverflow", options: { boundary: document.body } },
              { name: "computeStyles", options: { adaptive: false } },
            ],
          }}
        >
          <Nav horizontal className="px-2 gap-3 flex-nowrap">
            {options.map((option, idx) => (
              <NavLink
                key={idx}
                onClick={() => handleClick(option.value)}
                active={option.value === value}
              >
                <ColumnHeader
                  name={name}
                  value={option.value}
                  isLock={isLock}
                />
              </NavLink>
            ))}
          </Nav>
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    </div>
  );
}